function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function normalizeSearch(search) {
  return String(search || "")
    .trim()
    .toLowerCase();
}

function tokenize(search) {
  return normalizeSearch(search).split(/\s+/).filter(Boolean);
}

function mergeRanges(ranges) {
  if (!ranges.length) return [];

  const sorted = ranges.slice().sort((a, b) => a[0] - b[0]);
  const merged = [sorted[0]];

  for (let i = 1; i < sorted.length; i += 1) {
    const last = merged[merged.length - 1];
    const current = sorted[i];

    if (current[0] <= last[1]) {
      last[1] = Math.max(last[1], current[1]);
    } else {
      merged.push(current);
    }
  }

  return merged;
}

function dealerMatchScore(name, tokens) {
  const lowerName = normalizeSearch(name);

  if (!tokens.every((token) => lowerName.includes(token))) {
    return 0;
  }

  const query = tokens.join(" ");
  let score = 10;

  if (lowerName === query) score += 100;
  else if (lowerName.startsWith(query)) score += 80;
  else if (lowerName.startsWith(tokens[0])) score += 50;

  let position = 0;
  let inOrder = true;

  tokens.forEach((token) => {
    const index = lowerName.indexOf(token, position);
    if (index === -1) {
      inOrder = false;
      return;
    }
    position = index + token.length;
  });

  if (inOrder) score += 30;

  return score - lowerName.length * 0.01;
}

export function filterDealers(options, search) {
  const tokens = tokenize(search);
  if (!tokens.length) return options;

  return options
    .map((option) => ({
      option,
      score: dealerMatchScore(option.name, tokens),
    }))
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score)
    .map(({ option }) => option);
}

export function highlightDealerName(name, search) {
  const tokens = tokenize(search);
  if (!tokens.length) return escapeHtml(name);

  const lowerName = normalizeSearch(name);
  const ranges = [];

  tokens.forEach((token) => {
    let start = 0;

    while (start < lowerName.length) {
      const index = lowerName.indexOf(token, start);
      if (index === -1) break;

      ranges.push([index, index + token.length]);
      start = index + token.length;
    }
  });

  if (!ranges.length) return escapeHtml(name);

  const merged = mergeRanges(ranges);
  let html = "";
  let lastIndex = 0;

  merged.forEach(([start, end]) => {
    html += escapeHtml(name.slice(lastIndex, start));
    html += '<mark class="dealer-search__highlight" style="background:transparent;color:#E94C0A;font-weight:700;">';
    html += escapeHtml(name.slice(start, end));
    html += "</mark>";
    lastIndex = end;
  });

  html += escapeHtml(name.slice(lastIndex));
  return html;
}
